import classNames from 'classnames';
import * as React from 'react';
import { createRef, RefObject } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { Banner } from '../../typings/domain';
import { BannerPreviewPopup } from '../BannerPreviewPopup/BannerPreviewPopup';

import { GridBannerPreviewButton } from './GridBannerPreviewButton/GridBannerPreviewButton';
import './GridBannerPreviewCell.css';

export interface GridBannerPreviewCellProps {
    onClick: () => void;
    onGoToBannersButtonClick: (bannersIds: string[]) => void;
    bannersTotalCount: number;
    isGridScrolling: boolean;
    isTextBanner: boolean;
    banners?: Banner[];
    error?: string;
    id: string;
}

interface GridBannerPreviewCellState {
    isPopupVisible: boolean;
}

const BLOCK = 'grid-banner-preview-cell';

export class GridBannerPreviewCell extends React.Component<
    GridBannerPreviewCellProps,
    GridBannerPreviewCellState
> {
    private anchor: RefObject<GridBannerPreviewButton>;

    static getDerivedStateFromProps(
        props: GridBannerPreviewCellProps,
        state: GridBannerPreviewCellState
    ) {
        const { isGridScrolling } = props;
        const { isPopupVisible } = state;

        if (isGridScrolling && isPopupVisible) {
            return {
                isPopupVisible: false
            };
        }

        return null;
    }

    constructor(props: GridBannerPreviewCellProps) {
        super(props);

        this.anchor = createRef<GridBannerPreviewButton>();
        this.state = {
            isPopupVisible: false
        };
    }

    render() {
        const {
            banners,
            bannersTotalCount,
            isTextBanner,
            children,
            error,
            id
        } = this.props;

        const { isPopupVisible } = this.state;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: BLOCK,
                        mods: {
                            type: isTextBanner ? 'text' : 'image'
                        }
                    }),
                    TestBem.cls({
                        block: BLOCK,
                        mods: {
                            id
                        }
                    })
                )}
            >
                {children}
                <GridBannerPreviewButton
                    ref={this.anchor}
                    cls={Bem.cls(BLOCK, 'button')}
                    bannersCount={bannersTotalCount}
                    onClick={this.onClick}
                />
                <BannerPreviewPopup
                    id={id}
                    onClick={this.onPopupButtonClick}
                    anchor={this.anchor.current}
                    isVisible={isPopupVisible}
                    banners={banners}
                    bannersTotalCount={bannersTotalCount}
                    error={error}
                    onCancel={this.onCancel}
                />
            </div>
        );
    }

    private onClick = () => {
        this.props.onClick();
        this.setState({
            isPopupVisible: true
        });
    };

    private onCancel = () => {
        this.setState({
            isPopupVisible: false
        });
    };

    private onPopupButtonClick = () => {
        const { onGoToBannersButtonClick, banners = [] } = this.props;

        onGoToBannersButtonClick(banners.map(el => el.id));
    };
}
